import { Box, Stack, Typography } from '@mui/material'
import { whyChoose } from '@/content/copy'
import { featureIcons } from '@/lib/icons'
import { colors, fonts } from '@/theme'
import { Section } from '@/components/ui/Section'
import { SectionHeading } from '@/components/ui/SectionHeading'
import { Reveal } from '@/components/motion/Reveal'

/** "Why True Forge" — a bold numbered manifesto (full-width rows, oversized index). */
export function WhyChooseUs() {
  return (
    <Section sx={{ bgcolor: colors.surfaceAlt }}>
      <SectionHeading eyebrow={whyChoose.eyebrow} title={whyChoose.title} />
      <Stack spacing={0}>
        {whyChoose.items.map((item, i) => {
          const Icon = featureIcons[item.icon]
          return (
            <Reveal key={item.title} y={16}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', md: 'row' },
                  gap: { xs: 1.5, md: 5 },
                  py: { xs: 3.5, md: 4.5 },
                  borderTop: `1px solid ${colors.border}`,
                  '&:hover .wc-num': { color: colors.gold },
                  '&:hover .wc-title': { color: colors.gold },
                }}
              >
                <Typography
                  className="wc-num"
                  sx={{ fontFamily: fonts.display, fontWeight: 600, fontSize: { xs: 40, md: 68 }, lineHeight: 0.9, color: 'rgba(212,175,55,0.28)', minWidth: { md: 132 }, transition: 'color 300ms ease' }}
                >
                  {String(i + 1).padStart(2, '0')}
                </Typography>
                <Box sx={{ flex: 1, maxWidth: 720 }}>
                  <Stack direction="row" alignItems="center" spacing={1.5} sx={{ color: colors.gold, mb: 1.25 }}>
                    {Icon && <Icon size={20} />}
                    <Typography className="wc-title" variant="h4" component="h3" sx={{ color: colors.white, transition: 'color 300ms ease' }}>
                      {item.title}
                    </Typography>
                  </Stack>
                  <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                    {item.text}
                  </Typography>
                </Box>
              </Box>
            </Reveal>
          )
        })}
      </Stack>
    </Section>
  )
}
